import { FEATURES } from '@/lib/features'

/**
 * Node types a model must not be offered for, because the node behind them is
 * switched off. The library is the one surface that turns a model row into a
 * canvas node — through drag-and-drop and through "Add to canvas" — so the two
 * lists it renders (the catalogue and the user's saved models) both filter on
 * this. Keeping it in one module keeps the flag read in a single place.
 */
const HIDDEN_NODE_TYPES: readonly string[] = FEATURES.NODE_3D ? [] : ['3d']

/** True when nothing is hidden, so callers can skip the copy entirely. */
export const hasHiddenNodeTypes = HIDDEN_NODE_TYPES.length > 0

export function isHiddenNodeType(nodeType?: string | null): boolean {
  return HIDDEN_NODE_TYPES.includes(nodeType ?? '')
}
